import {AppDispatch} from "../store";
import {EnumLanguage} from "../../enums/EnumLanguage";
import {appSlice} from "../reducers/AppSlice";
import {EnumPages} from "../../enums/EnumPages";
import {EnumTextTypes} from "../../enums/EnumTextTypes";
import {appApi} from "../../api/appApi";
import {toast} from "react-toastify";
import {UpdatePageTextDto} from "../../api/dto/update-page-text.dto";

export const getTextsThunk = () => async (dispatch: AppDispatch) => {
    try {
        const {data} = await appApi.getPagesTexts()
        const result = data.map(row => {
            return {
                id: row.id,
                page: row.page_name as EnumPages,
                type: row.type as EnumTextTypes,
                text: {
                    [EnumLanguage.en]: row.en,
                    [EnumLanguage.ru]: row.ru,
                    [EnumLanguage.cn]: row.cn,
                }
            }
        })


        dispatch(appSlice.actions.setPagesText(result))
        return true
    } catch (error) {
        console.log(error)
        toast.error('Ошибка при загрузке текста')
        return true
    }


}

export const updatePageTextThunk = (dto: UpdatePageTextDto) => async (dispatch: AppDispatch) => {
    try {
        const {data} = await appApi.updatePageText(dto)
        dispatch(appSlice.actions.updatePagesText({...dto}))
        toast.success(data)
    } catch(error) {
        toast.error('Ошибка при обновлении текста')
        console.log(error)
    }
}